import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=ba0bb1c4&"
import script from "./Chart.vue?vue&type=script&lang=ts&"
export * from "./Chart.vue?vue&type=script&lang=ts&"
import style0 from "./Chart.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports